import React from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { CircularProgress, Stack } from '@mui/material';
import { bpfAPI, TemplatesList, TemplatesResponse, GetTemplatesVariables } from 'modules/stages';

import { accountSelectors } from '../../redux/accountReducer';
import { RenderWithFallback } from '../../components/shared/Conditional/RenderWithFallback';

export const ListOfTemplates = () => {
  const accountId = useSelector(accountSelectors.accountId);

  const { data, loading, error } = useQuery<TemplatesResponse, GetTemplatesVariables>(bpfAPI.fetchTemplates, {
    variables: { input: { accountId } },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <RenderWithFallback
      error={error}
      isLoading={loading}
      fallBack={
        <Stack alignItems="center" justifyContent="center">
          <CircularProgress />
        </Stack>
      }
    >
      <TemplatesList templates={data?.bpf?.templates ?? []} />
    </RenderWithFallback>
  );
};
